<template>
  <div class="login-page">
    <div class="login-card anim-fade-in-scale">
      <img src="../../assets/xiaohui.png" alt="校徽" class="login-logo" />
      <h1 class="login-title">SDU—HFLIBS</h1>
      <p class="login-subtitle">可视化分析系统</p>
      <hr class="rule-accent" />
      <p class="login-desc">管理员登录入口</p>

      <el-form :model="form" :rules="rules" ref="formRef" class="login-form">
        <el-form-item prop="account">
          <el-input
            v-model="form.account"
            placeholder="请输入管理员账号"
            prefix-icon="el-icon-user"
            maxlength="6"
            show-word-limit
          />
        </el-form-item>

        <el-form-item prop="password">
          <el-input
            v-model="form.password"
            type="password"
            placeholder="请输入密码"
            prefix-icon="el-icon-lock"
            show-password
            @keyup.enter.native="submit"
          />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submit" :loading="logining" class="login-btn">
            登 录
          </el-button>
        </el-form-item>
      </el-form>

      <div class="login-footer">
        <a @click.prevent="toUserLogin" class="reg-link">返回用户登录</a>
      </div>
    </div>
  </div>
</template>

<style scoped>
.login-page {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 32px 20px;
}

.login-card {
  width: 100%;
  max-width: 420px;
  background: var(--bg-surface);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-elevated);
  padding: 44px 36px 36px;
  text-align: center;
}

.login-logo {
  width: 56px; height: 56px;
  border-radius: 50%;
  margin-bottom: 14px;
}

.login-title {
  font-family: var(--font-display);
  font-size: 2rem; font-weight: 500;
  color: var(--text-primary);
  margin: 0 0 2px;
  letter-spacing: 0.05em;
}

.login-subtitle {
  font-family: var(--font-body);
  font-size: 0.9rem; font-weight: 400;
  color: var(--text-muted);
  margin: 0 0 16px;
  letter-spacing: 0.12em;
}

.rule-accent {
  width: 48px; height: 2px;
  background: var(--accent-primary);
  border: none;
  margin: 0 auto 14px;
}

.login-desc {
  font-size: 0.82rem;
  color: var(--text-muted);
  margin: 0 0 28px;
}

.login-form {
  text-align: left;
  margin-top: 4px;
}

.login-btn {
  width: 100%; height: 44px;
  font-size: 0.95rem;
  letter-spacing: 0.25em;
  border-radius: var(--radius-sm);
  margin-top: 4px;
}

.login-footer {
  text-align: center;
  font-size: 0.82rem;
  margin-top: 20px;
}

.reg-link {
  color: var(--accent-primary);
  cursor: pointer;
  transition: color var(--transition-fast);
}
.reg-link:hover {
  color: #9A6F0A;
  text-decoration: underline;
}

@media screen and (max-width: 480px) {
  .login-card { padding: 32px 20px 28px; }
  .login-title { font-size: 1.6rem; }
}
</style>

<script>
export default {
  data() {
    return {
      logining: false,
      form: { account: '', password: '' },
      rules: {
        account: [{ required: true, message: '请输入管理员账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
    }
  },

  methods: {
    toUserLogin() { this.$router.push('/login'); },

    submit() {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return;
        this.logining = true;
        try {
          const resp = await this.$axios.post('/adm/login', this.form);
          if (resp.data.code === 0) {
            this.$message.success('登录成功');
            this.$router.push('/admin/home');
          } else {
            this.$message.error(resp.data.msg || '登录失败');
          }
        } catch (e) {
          this.$message.error('登录请求失败，请检查网络连接');
        } finally {
          this.logining = false;
        }
      });
    }
  }
}
</script>
